import React, { FC } from 'react'
import cx from 'classnames'

import { LinkProps } from '../../Link'

import * as SC from './styled'

export type FooterLegalProps = {
  className?: string
  title: string
  links: LinkProps[]
  cookiesSettings: {
    text: string
    onClick: () => void
  }
}

const FooterLegal: FC<FooterLegalProps> = (props) => {
  const { className, title, links, cookiesSettings } = props

  return (
    <SC.Container className={cx(className)}>
      <SC.Column>
        <SC.Title>{title}</SC.Title>
        <SC.ListWrapper>
          <SC.CookiesSettings onClick={cookiesSettings.onClick} role="button">
            {cookiesSettings.text}
          </SC.CookiesSettings>
          {links.map((item, index) => (
            <SC.ListItem key={index}>
              <SC.Lk {...item} />
            </SC.ListItem>
          ))}
        </SC.ListWrapper>
      </SC.Column>
    </SC.Container>
  )
}

export default FooterLegal
